import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowOutExternal24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowOutExternal24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.25 4a.75.75 0 0 0 0 1.5h3.19l-6.47 6.47a.75.75 0 1 0 1.06 1.06l6.47-6.47v3.19a.75.75 0 0 0 1.5 0V4zM4 8.75A3.25 3.25 0 0 1 7.25 5.5H10A.75.75 0 0 1 10 7H7.25A1.75 1.75 0 0 0 5.5 8.75v8c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 17 16.75V14a.75.75 0 0 1 1.5 0v2.75A3.25 3.25 0 0 1 15.25 20h-8A3.25 3.25 0 0 1 4 16.75z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowOutExternal24);
